<template>
  <b-modal
     :visible="visible"
     :header-class="`offer-colour green`"
     :header-text-variant="headerTextVariant"
     title="Send a message"
     @ok="sendMessage"
     @hide="closeModal"
     hide-footer
   >
     <template #default="{ hide }">
       <form @submit.prevent="hide({ sendMessage: true })">
         <input v-model="subject" placeholder="Subject" />
         <textarea v-model="body" rows="8" placeholder="Message..." />
         <b-row>
           <b-col cols="8">
            <b-button variant="outline-primary" @click="hide">Cancel</b-button>
           </b-col>
           <b-col cols="4">
            <input type="submit" />
           </b-col>
         </b-row>
       </form>
     </template>
   </b-modal>
</template>

<script lang="js">
import dig from 'spiceutils/dist/dig'

export default {
  data() {
    return {
      variants: ['light'],
      headerTextVariant: 'light',
    }
  },
  computed: {
    visible() {
      return this.$store.state.comments.modalOpen
    },
    subject: {
      get() {
        return this.$store.state.comments.commentSubject
      },
      set(value) {
        this.$store.commit('comments/setMessageSubject', value)
      },
    },
    body: {
      get() {
        return this.$store.state.comments.commentBody
      },
      set(value) {
        this.$store.commit('comments/setMessageBody', value)
      },
    },
  },
  methods: {
    sendMessage() {
      this.$store.dispatch('comments/sendMessage')
    },
    closeModal(event) {
      if (dig(event, 'trigger', 'sendMessage')) {
        event.preventDefault()
        this.sendMessage()
      } else {
        this.$store.dispatch('comments/closeModal')
      }
    },
  },
}
</script>
